import {call, put} from 'redux-saga/effects';
import {receiveInterlineOperators} from "../actions/interlineOperatorsActions";
import {fetchInterlineOperatorsData} from "../api/fetchInterlineOperatorsData";

export default function* getInterlineOperatorsData(action) {
  try {
    const interlineOperatorsData = yield call(fetchInterlineOperatorsData);
    yield put(receiveInterlineOperators(interlineOperatorsData));
  } catch (e) {
    console.log(e)
  }
}



// WEBPACK FOOTER //
// ./src/sagas/interlineOperatorsSaga.js